
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[...path]",
      function () {
        return require("private-next-pages/posts/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[...path]"])
      });
    }
  